import React from 'react'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import { Alert, Divider, Flex, List, Skeleton, Space, Typography } from 'antd'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { isNumber } from 'lodash'
import PatternIcon from '../../../../../components/common/PatternIcon'
import logo from '../../../../../../assets/images/sense_logo2.png'
import MarkdownRenderer from '../../../../../components/common/markdown-renderer'
const { Title, Text, Paragraph } = Typography

const QuestionContent = ({ question }) => (
    <div key={question.id}>
        <Title level={question.isChild ? 3 : 2} style={{ margin: 0 }}>
            {question.name}
        </Title>
        <Paragraph>
            <Text>{question.content}</Text>
        </Paragraph>
        {question.gradingReferenceContent && (
            <Paragraph>
                <Text strong>Grading reference content:</Text> <MarkdownRenderer content={question.gradingReferenceContent} />  
            </Paragraph>
        )}
        <Flex justify='space-between'>
            {isNumber(question.weight) && (
                <Paragraph>
                    <Text strong>Weight:</Text> {question.weight} points
                </Paragraph>
            )}
            {question.wordsLimit && (
                <Paragraph>
                    <Text strong>Limit:</Text> {question.wordsLimit} words
                </Paragraph>
            )}
        </Flex>
        <Title level={question.isChild ? 4 : 3} style={{ margin: 0 }}>
            Categories
        </Title>
        <List
            dataSource={question.categories}
            renderItem={category => (
                <List.Item key={category.id}>
                    <List.Item.Meta
                        title={
                            <Space>
                                <PatternIcon id={category.id} colorId={category.colorId} showId={false} />{' '}
                                <Title level={question.isChild ? 5 : 4} style={{ margin: 0 }}>
                                    {category.name}
                                </Title>
                            </Space>
                        }
                        description={
                            <>
                                {category.description && (
                                    <Paragraph>
                                        <Text strong>Description:</Text> <MarkdownRenderer content={category.description} />
                                    </Paragraph>
                                )}
                                {category.feedback && (
                                    <Paragraph>
                                        <Text strong>Feedback:</Text> {category.feedback}
                                    </Paragraph>
                                )}
                                {category.grade !== null && (
                                    <Paragraph>
                                        <Text strong>Grade:</Text> {category.grade}
                                    </Paragraph>
                                )}
                            </>
                        }
                    />
                </List.Item>
            )}
        />
    </div>
)

const RubricPreview = () => {
    const { token } = useParams()
    const versionId = useVersionId()
    const assignmentName = useSelector(assignmentSelectors.name)

    const { data: questions, isFetching, error } = useFetchQuestionsQuery({ token, versionId })

    if (isFetching) return <Skeleton active />
    if (error) return <Alert message={error} type='error' showIcon />

    return (
        <div>
            <Flex justify='space-between'>
                <Title level={1} style={{ fontSize: '1.8rem', margin: '0 0 16px 0' }}>
                    {assignmentName}
                </Title>
                <a href='https://www.sense.education/'>
                    <img
                        src={logo}
                        alt='Sense Education'
                        style={{
                            width: '120px',
                            objectFit: 'contain',
                        }}
                    />
                </a>
            </Flex>
            {questions.map(question => (
                <div key={question.id}>
                    {question.children ? (
                        <>
                            <Title level={2} style={{ margin: 0 }}>
                                {question.name}
                            </Title>
                            <Paragraph>
                                <Text>{question.content}</Text>
                            </Paragraph>
                            {question.children.map(childQuestion => (
                                <div key={childQuestion.id} style={{ marginLeft: '1.5rem', marginTop: '1rem' }}>
                                    <QuestionContent question={{ ...childQuestion, isChild: true }} />
                                </div>
                            ))}
                        </>
                    ) : (
                        <QuestionContent question={question} />
                    )}
                    <Divider />
                </div>
            ))}
        </div>
    )
}

export default RubricPreview
